import React, { FC, memo } from "react";
import SummaryBlock from "./Summary/SummaryBlock";

const SideDeliveryInfo: FC = () => {
  return <SummaryBlock />;
};

export default memo(SideDeliveryInfo);
